import { gql } from "@apollo/client";

export const GET_HOMEOWNER_BIO = gql`
  query GetHomeOwnerBio($homeOwnerId: String!) {
    getHomeOwnerBio(homeOwnerId: $homeOwnerId) {
      _id
      homeOwnerId
      hireLikelihood
      decisionMakers
      worksRemotely
      workedWithDesigner
      experience {
        rating
        notes
      }
      entertainRegularly
      hasPets
      pets {
        type
        count
      }
      hobbies
      household {
        adults
        kids
        kidsAges
      }
      wishList
      notes
      designerNotes
      image {
        _id
        url
      }
    }
  }
`;

export const CREATE_HOMEOWNER_BIO = gql`
  mutation CreateHomeOwnerBio(
    $homeOwnerId: String!
    $hireLikelihood: String
    $decisionMakers: String
    $worksRemotely: Boolean
    $workedWithDesigner: Boolean
    $experience: HomeOwnerExperienceInput
    $entertainRegularly: Boolean
    $hasPets: Boolean
    $pets: [HomeOwnerPetInput]
    $hobbies: [String]
    $household: HomeOwnerHouseholdInput
    $wishList: [String]
    $notes: String
    $designerNotes: String
    $image: ID
  ) {
    createHomeOwnerBio(
      homeOwnerId: $homeOwnerId
      hireLikelihood: $hireLikelihood
      decisionMakers: $decisionMakers
      worksRemotely: $worksRemotely
      workedWithDesigner: $workedWithDesigner
      experience: $experience
      entertainRegularly: $entertainRegularly
      hasPets: $hasPets
      pets: $pets
      hobbies: $hobbies
      household: $household
      wishList: $wishList
      notes: $notes
      designerNotes: $designerNotes
      image: $image
    ) {
      _id
      homeOwnerId
    }
  }
`;

export const UPDATE_HOMEOWNER_BIO = gql`
  mutation UpdateHomeOwnerBio(
    $_id: ID!
    $hireLikelihood: String
    $decisionMakers: String
    $worksRemotely: Boolean
    $workedWithDesigner: Boolean
    $experience: HomeOwnerExperienceInput
    $entertainRegularly: Boolean
    $hasPets: Boolean
    $pets: [HomeOwnerPetInput]
    $hobbies: [String]
    $household: HomeOwnerHouseholdInput
    $wishList: [String]
    $notes: String
    $designerNotes: String
    $image: ID
  ) {
    updateHomeOwnerBio(
      _id: $_id
      hireLikelihood: $hireLikelihood
      decisionMakers: $decisionMakers
      worksRemotely: $worksRemotely
      workedWithDesigner: $workedWithDesigner
      experience: $experience
      entertainRegularly: $entertainRegularly
      hasPets: $hasPets
      pets: $pets
      hobbies: $hobbies
      household: $household
      wishList: $wishList
      notes: $notes
      designerNotes: $designerNotes
      image: $image
    ) {
      _id
      homeOwnerId
    }
  }
`;
